import { textChooser } from "../../util/textChooser";
import successImg from "../../../assets/images/success.png";
import "./postulation.style.scss";

export default function FailedPostulation() {
  return (
    <div className="postulation-container">
      <img src={successImg} width={100} height={100} alt="success" />
      <h2>{textChooser('txt189')}</h2>
      <p>{textChooser('txt66')}</p>
    </div>
  );
}